"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonAttributesSpanProcessor = exports.setSessionId = exports.setBrowserRoute = void 0;
const uuid_1 = require("uuid");
const ua_parser_js_1 = require("ua-parser-js");
var AttributesNames;
(function (AttributesNames) {
    AttributesNames["sessionId"] = "session.id";
    AttributesNames["browserRoute"] = "browser.route";
    AttributesNames["browserReferrer"] = "browser.referrer";
    AttributesNames["browserUrl"] = "browser.url";
    AttributesNames["browserLanguage"] = "browser.language";
    AttributesNames["httpUserAgent"] = "http.user_agent";
    AttributesNames["browserName"] = "browser.name";
    AttributesNames["browserOS"] = "browser.os";
    AttributesNames["browserDevice"] = "browser.device";
    AttributesNames["sitespectCookie"] = "sitespect_cookie";
})(AttributesNames || (AttributesNames = {}));
let httpRoute = undefined;
let sessionId = undefined;
/**
 * Set the route template of the current page.
 * On nextjs you can use Router.pathname to get the current route.
 * Example:
 * On the page /programma/series-name/1234, the route will be /programma/[series-name-slug]/[video-id]
 * @param route
 */
function setBrowserRoute(route) {
    httpRoute = route;
}
exports.setBrowserRoute = setBrowserRoute;
function setSessionId(id) {
    sessionId = id;
}
exports.setSessionId = setSessionId;
class CommonAttributesSpanProcessor {
    constructor(processor) {
        this.processor = processor;
    }
    forceFlush() {
        return this.processor.forceFlush();
    }
    onStart(span, parentContext) {
        if (!sessionId) {
            sessionId = (0, uuid_1.v4)().replace(/-/g, '');
        }
        span.setAttribute(AttributesNames.sessionId, sessionId);
        if (httpRoute) {
            span.setAttribute(AttributesNames.browserRoute, httpRoute);
        }
        if (typeof document !== 'undefined') {
            span.setAttribute(AttributesNames.browserReferrer, document.referrer);
            const sitespectCookieArray = document.cookie
                ?.split('; ')
                ?.filter((row) => row.startsWith('SSSC'))[0]
                ?.split('|')[1];
            if (sitespectCookieArray) {
                span.setAttribute(AttributesNames.sitespectCookie, sitespectCookieArray.toString());
            }
        }
        if (typeof location !== 'undefined') {
            span.setAttribute(AttributesNames.browserUrl, location.href);
        }
        if (typeof navigator !== 'undefined') {
            const parser = new ua_parser_js_1.UAParser(navigator.userAgent);
            const { browser, device, os } = parser.getResult();
            span.setAttribute(AttributesNames.httpUserAgent, navigator.userAgent);
            span.setAttribute(AttributesNames.browserLanguage, navigator.language);
            span.setAttribute(AttributesNames.browserName, browser.name);
            span.setAttribute(AttributesNames.browserOS, os.name);
            span.setAttribute(AttributesNames.browserDevice, device.model);
        }
        this.processor.onStart(span, parentContext);
    }
    onEnd(span) {
        this.processor.onEnd(span);
    }
    shutdown() {
        return this.processor.shutdown();
    }
}
exports.CommonAttributesSpanProcessor = CommonAttributesSpanProcessor;
